export enum ContentTypeEnum {
  ASSET_LIBRARY = 1,
  TEMPLATE_LIBRARY = 2,
}
